import React from "react";
import { RadioButton } from "@graffer-inc/console-design-kit";
import { CSVEncoding } from "../../../../application/domain/file-encoding";

type Props = {
  encoding: CSVEncoding;
  requireSelectableRawValue: boolean;
  onChangeCSVEncoding: (encoding: CSVEncoding) => void;
  onChangeRequireSelectableRawValue: (isRequired: boolean) => void;
};

export const CsvOutputValueExpOption: React.FC<Props> = ({
  encoding,
  requireSelectableRawValue,
  onChangeCSVEncoding,
  onChangeRequireSelectableRawValue,
}) => {
  return (
    <>
      <div className="mb-2">
        <h5 className="title is-5">オプション</h5>
      </div>
      <div className="mt-2">
        <RadioButton
          label="文字のエンコーディング"
          description="文字コードが変更できます。Shift_JISで文字化けが発生した場合、UTF-8に変更することで正常に表示できます。"
          options={[
            {
              value: "Shift_JIS" as CSVEncoding,
              name: "Shift_JIS",
            },
            {
              value: "utf-8" as CSVEncoding,
              name: "UTF-8",
            },
          ]}
          required={true}
          value={encoding}
          onChange={(e) => {
            onChangeCSVEncoding(e.target.value as CSVEncoding);
          }}
          direction={"row"}
        />
      </div>
      <div className="mt-2">
        <RadioButton
          label="選択式フォームの出力方法"
          description="選択式フォーム（ラジオボックス・セレクトボックス・チェックボックス）で出力する項目を選択してください。表示名とは、申請フォームに表示されているテキストです。管理用コードとは、表示名と別にシステム連携に使用するためなどに設定された文字列です。"
          options={[
            {
              value: "label",
              name: "表示名",
            },
            {
              value: "value",
              name: "管理用コード",
            },
          ]}
          required
          value={requireSelectableRawValue ? "value" : "label"}
          onChange={(e) => {
            if (e.target.value === "label") {
              onChangeRequireSelectableRawValue(false);
            }
            if (e.target.value === "value") {
              onChangeRequireSelectableRawValue(true);
            }
          }}
          direction={"row"}
        />
      </div>
    </>
  );
};
